import conf from '../../conf';
import { checkIsAuthenticated, getAuthLogout } from '../../lib/helpers';

// D14 (PF-8560, refined 2026-08-26): AvaApp's session isn't replaced by following a magic
// link (see avaapp's auth.js/session.js) - an attendee already signed in as someone else has
// to be logged out first, or the magic link is wasted and they land in chat as their old
// identity. An attendee already signed in as the Crush temp user can skip straight to chat.
//
// checkIsAuthenticated(), not just window.AvaAppUser, decides whether anyone is logged in at
// all - an aui-only session (no AvaAppUser) is still an existing identity the magic link would
// clash with, so it must go through logout too, same as any other non-Crush AvaAppUser session.
export const getExistingSessionRedirect = (): string | null => {
  if (!checkIsAuthenticated()) return null;

  const avataxAccountId = window.AvaAppUser?.avataxAccountId;
  if (conf.CRUSH_AVATAX_ACCOUNT_ID && avataxAccountId === conf.CRUSH_AVATAX_ACCOUNT_ID) {
    // BUY_CLIENT_URL (includes /buy), not CLIENT_URL (AvaApp shell root) - /aviator-crush is
    // this app's own route, and CLIENT_URL is only for AvaApp shell paths like /auth/logout.
    return `${conf.BUY_CLIENT_URL}/aviator-crush`;
  }

  return `${conf.CLIENT_URL}${getAuthLogout()}`;
};
